import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { getEventBySlug } from "@/utils/content";

export default function TimelineReview() {
  const sample = getEventBySlug("cross-year-chorus-change");

  if (!sample) return null;

  return (
    <section id="method" className="w-full bg-primary-950">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3">
          <span className="flex w-fit items-center gap-2 rounded-md bg-accent-500/20 px-2.5 py-1 text-xs font-medium tracking-wide text-accent-200">
            <i className="ri-route-line text-sm"></i>
            复盘方法
          </span>
          <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
            一件事，我们这样拆开看
          </h2>
          <p className="max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            以「{sample.title}」为例：先放进前因，再按发生顺序排好经过，最后给出结果与现状。
            三段拼在一起，就是完整的一件事。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div className="rounded-lg border border-primary-800 bg-primary-900/50 p-5 md:p-6">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-seedling-line text-lg"></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-background-50">前因</h3>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">{sample.cause}</p>
          </div>

          <div className="rounded-lg border border-primary-800 bg-primary-900/50 p-5 md:p-6">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-loader-4-line text-lg"></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-background-50">经过</h3>
            </div>
            <ul className="mt-4 space-y-3">
              {sample.development.map((item) => (
                <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-background-200">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-accent-400"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-primary-800 bg-primary-900/50 p-5 md:p-6">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-flag-line text-lg"></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-background-50">结果</h3>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">{sample.result}</p>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-primary-800 bg-primary-900/50 p-5 md:p-8">
          <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
            <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-background-50">
              <i className="ri-time-line text-xl text-primary-400"></i>
              完整时间线
            </h3>
            <Link
              to={`/event/${sample.slug}`}
              className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-300 transition-colors hover:text-accent-200"
            >
              打开完整事件
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <ol className="relative flex flex-col gap-6 border-l border-primary-700/60 pl-6 md:gap-7">
            {sample.timeline.map((node) => (
              <li key={node.title} className="relative">
                <span className="absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-primary-500 bg-primary-950">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-400"></span>
                </span>
                <div className="flex flex-col gap-1.5 md:flex-row md:items-baseline md:gap-4">
                  <span className="shrink-0 rounded-md bg-primary-800 px-2 py-0.5 text-xs font-medium text-accent-200 md:w-40">
                    {node.time}
                  </span>
                  <div>
                    <h4 className="font-heading text-base font-semibold text-background-50">
                      {node.title}
                    </h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-background-300">
                      {node.desc}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}